export const MESSAGE_STATES = {
  contact_missing: {
    type: 'error',
    alertClass: 'danger',
    form: { enabled: true },
    ariaInvalid: true,
    title: 'An error has occurred.',
    message: 'Please enter an email or phone number to continue.',
  },
  email_missing: {
    type: 'error',
    form: { enabled: true },
    ariaInvalid: true,
  },
  phone_missing: {
    type: 'error',
    form: { enabled: true },
    ariaInvalid: true
  },
  failure: {
    type: 'error',
    alertClass: 'danger',
    title: 'An error has occurred.',
    message: 'Please resubmit your contact information.',
    form: { enabled: true },
    ariaInvalid: true
  },
  duplicate: {
    type: 'success',
    alertClass: 'success',
    title: 'Thank you!',
    message: 'You are already signed up to receive a notification if this product is back in stock.',
    form: { enabled: false },
    ariaInvalid: true
  },
  success: {
    type: 'success',
    alertClass: 'success',
    title: 'Thank you!',
    message: 'We\'ll send you a notification if this product is back in stock.',
    form: { enabled: false },
    ariaInvalid: false
  },
  init: {
    type: '',
    alertClass: '',
    title: '',
    message: '',
    form: { enabled: true },
    ariaInvalid: false
  }
};

export const INHOUSE_STATUS_MAP = {
  Success: 'success',
  OPS_ERROR_200: 'email_missing',
  OPS_ERROR_201: 'duplicate',
  OPS_ERROR_203: 'failure',
  OPS_ERROR_204: 'failure',
  OPS_ERROR_205: 'failure',
  OPS_DECRYPT_ERROR: 'failure'
};

// eslint-disable-next-line max-len
export const DEFAULT_LEGAL_DISCLAIMER = 'By clicking “Notify Me,” you consent to the Home Depot contacting you at the number provided when your item is back in stock, including through the use of automated technology, SMS/MMS, and/or prerecorded, AI, or artificial messages (“Back In Stock Texting Program”). Messaging frequency varies. Consent is not a condition of purchase, and you may opt out of the Back In Stock Texting Program messages at any time by replying with your 5-digit code provided at Sign-Up Confirmation to stop texts for this item or by replying STOP to stop texts for all your open orders. You may also opt out by calling 1-800-HOMEDEPOT. Msg & data rates may apply. You also agree to Home Depot Privacy & Security Statement.';

export const BUNDLE_TRACK_OOS_MESSAGE = 'Notify me when the bundle is available again.';

export const ITEM_TRACK_OOS_MESSAGE_EMAIL = 'Receive an email when this item is back in stock.';

// eslint-disable-next-line max-len
export const ITEM_TRACK_OOS_MESSAGE_EMAIL_AND_TEXT = 'Receive an email and/or text notification when this item is back in stock.';
